"use strict";

module.exports = /* @ngInject */ function($rootScope, $state) {
  $rootScope.$on("$stateChangeError", function() {
    $state.go("error");
  });
};



// WEBPACK FOOTER //
// ./app/config/routingSetup.js